import { isMini } from '@antv/l7-utils';
var containerCounter = 0;
export function createRendererContainer(domId) {
  if (isMini) {
    return null;
  }

  var $wrapper = domId;

  if (typeof domId === 'string') {
    $wrapper = document.getElementById(domId);
  }

  if ($wrapper) {
    var $container = document.createElement('div');
    $container.style.cssText += "\n      position: absolute;\n      z-index:2;\n      height: 100%;\n      width: 100%;\n      pointer-events: none;\n    ";
    $container.id = "l7-scene-".concat(containerCounter++);
    $container.classList.add('l7-scene');
    $wrapper.appendChild($container);
    return $container;
  }

  return null;
}
/**
 * 检测触发事件是否是在 marker/popup 上发生，若是则会发生冲突（发生冲突时 marker/popup 事件优先）
 * @param obj
 * @returns
 */

export function isEventCrash(obj) {
  var _obj$target, _obj$target$path;

  var notCrash = true;
  obj === null || obj === void 0 ? void 0 : (_obj$target = obj.target) === null || _obj$target === void 0 ? void 0 : (_obj$target$path = _obj$target.path) === null || _obj$target$path === void 0 ? void 0 : _obj$target$path.map(function (p) {
    if (p !== null && p !== void 0 && p.classList) {
      var _p$classList;

      p === null || p === void 0 ? void 0 : (_p$classList = p.classList) === null || _p$classList === void 0 ? void 0 : _p$classList.forEach(function (n) {
        if (n === 'l7-marker' || n === 'l7-popup') {
          notCrash = false;
        }
      });
    }
  });
  return notCrash;
}